import { CustomLink } from "@pepperstone/pepper-ui-kit";
import React, { MouseEventHandler } from "react";

import {
  FacebookRoudedIcon,
  InstagramRoundedIcon,
  LinkedinRoundedIcon,
  XRoundedIcon,
  YoutubeRoundedIcon,
} from "../Icons";

export type SocialNetwork =
  | "X"
  | "Facebook"
  | "Instagram"
  | "Linkedin"
  | "Youtube";

export type SocialLink = {
  name: SocialNetwork;
  icon: React.JSX.Element;
  href: string;
  ariaLabel: string;
};

const links: SocialLink[] = [
  {
    name: "X",
    href: "https://x.com/PepperstoneFX",
    icon: <XRoundedIcon />,
    ariaLabel: "X link",
  },
  {
    name: "Facebook",
    href: "https://www.facebook.com/Pepperstonefx",
    icon: <FacebookRoudedIcon />,
    ariaLabel: "Facebook link",
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/pepperstonefx",
    icon: <InstagramRoundedIcon />,
    ariaLabel: "Instagram link",
  },
  {
    name: "Linkedin",
    href: "https://www.linkedin.com/company/pepperstone",
    icon: <LinkedinRoundedIcon />,
    ariaLabel: "Linkedin link",
  },
  {
    name: "Youtube",
    href: "https://www.youtube.com/@Pepperstone",
    icon: <YoutubeRoundedIcon />,
    ariaLabel: "Youtube link",
  },
];

export type TrackLinks = { [key in SocialNetwork]: MouseEventHandler };

export type SocialLinksProps = { trackLinks: TrackLinks };

export const SocialLinks = ({ trackLinks }: SocialLinksProps) => (
  <ul
    data-testid="social-links"
    className="flex items-center gap-6 duration-300 ease-in-out [&_a:hover]:text-text-blue [&_a]:flex [&_a]:items-center [&_a]:justify-center [&_a]:transition-colors"
  >
    {links.map((icon) => (
      <li key={icon.href}>
        <CustomLink
          href={icon.href}
          target="_blank"
          onClick={trackLinks[icon.name]}
          aria-label={icon.ariaLabel}
        >
          <div className="pointer-events-none">{icon.icon}</div>
        </CustomLink>
      </li>
    ))}
  </ul>
);
